import { IProductDataV3, Product } from '@df/catalog/product/product';
export namespace NFurnitureAssembly {
    export enum EType {
        sofa = 'sofa',
        garden = 'garden'
    }
    export const Endpoints = {
        add: 'assembly/add',
        remove: 'assembly/remove'
    };
    export interface IBasketDataConfigurationItem {
        added?: boolean;
        eligible?: boolean;
        quote_item_id?: number;
        sku?: string;
    }
    export interface IAssemblyItem {
        product: Product<IProductDataV3>;
        type: EType;
    }
}
